/** `{value,label}` options for a list of plain values. */
export const toOptions = (
  values: readonly string[],
  labelFor: (value: string) => string = (v) => v,
) => values.map((value) => ({ value, label: labelFor(value) }));
